import { Paragraph, TextRun } from 'docx'
import { ProcessingState, ProcessingContext } from '../types'

/**
 * Process code block lines and return paragraph or null
 */
export function processCodeBlock(
  line: string,
  trimmedLine: string,
  state: ProcessingState,
  context: ProcessingContext
): Paragraph | null {
  if (trimmedLine.startsWith('```')) {
    if (!state.isInCodeBlock) {
      state.isInCodeBlock = true
      state.codeBlockContent = []
    } else {
      state.isInCodeBlock = false
      if (state.codeBlockContent.length > 0) {
        const paragraph = new Paragraph({
          children: [new TextRun({ 
            text: state.codeBlockContent.join('\n'),
            font: 'Courier New',
            size: context.fontSize - 2,
            color: '000000'
          })],
          spacing: { before: 120, after: 120 }
        })
        state.codeBlockContent = []
        return paragraph
      }
      state.codeBlockContent = []
    }
    return null
  }

  if (state.isInCodeBlock) {
    state.codeBlockContent.push(line)
    return null
  }

  return null
}